import React from 'react';
import { formatFileSize } from './fileUtils';

const fileAttachmentPlaceholder = (
  <span style={{ color: 'rgba(224, 224, 224, 0.5)', fontStyle: 'italic', fontSize: '0.9em' }}>
    File attachments are not available
  </span>
);

export const renderFileMessage = (filename, sizeBytes, url, isUserMessage, onFileDownloadError = null, fileHash = null) => {
  const fileSize = formatFileSize(sizeBytes);

  const styles = {
    user: {
      container: {
        backgroundColor: '', 
        color: '#e0e0e0'
      },
      icon: '#e0e0e0',
      secondaryText: 'rgba(224, 224, 224, 0.7)'
    },
    other: {
      container: {
        backgroundColor: '',
        color: '#e0e0e0'
      },
      icon: '#e0e0e0',
      secondaryText: 'rgba(224, 224, 224, 0.7)'
    }
  };

  const currentStyle = isUserMessage ? styles.user : styles.other;

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'stretch',
      padding: '8px 10px',
      borderRadius: '12px',
      width: '100%',
      minWidth: 0,
      overflow: 'hidden',
      ...currentStyle.container
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginBottom: '4px',
        width: '100%',
        minWidth: 0,
        overflow: 'hidden',
        gap: '6px'
      }}>
        <svg 
          width="24"
          height="24"
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          style={{ flexShrink: 0, width: '24px', height: '24px' }}
        >
          <path 
            d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" 
            stroke={currentStyle.icon} 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M14 2V8H20" 
            stroke={currentStyle.icon} 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
        <span
          style={{ 
            color: currentStyle.container.color, 
            textDecoration: 'none',
            fontWeight: '500',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            flex: '1 1 auto',
            minWidth: 0,
            maxWidth: '100%',
            textAlign: 'left',
            display: 'block',
            padding: '0',
            margin: '0',
            fontSize: '1em',
            cursor: 'default',
            width: '100%'
          }}
          title={filename || url.split('/').pop()}
        >
          {filename || url.split('/').pop()}
        </span>
      </div>
      {sizeBytes > 0 && (
        <div style={{ 
          fontSize: '0.8em', 
          color: currentStyle.secondaryText,
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent: 'center'
        }}>
          <span style={{ marginRight: '0.25em' }}>↓</span>
          {fileSize}
        </div>
      )}
    </div>
  );
};

export const processMessageText = (text, isUserMessage, messageMeta = null, messageType = null, onFileDownloadError = null, attachments = null) => {
  if (attachments && Array.isArray(attachments) && attachments.length > 0 && messageType === 'file_message') {
    return fileAttachmentPlaceholder;
  }
  return text;
};

